module.exports = __webpack_public_path__ + "img/testPhone_a.62efc0e0.png";